import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FeedbackPayload {
    star_rating: number | null;
    text_rating: string;
    abusive: boolean;
    biased: boolean;
    helpful: string;
    remarks: string;
    chat_id: number | string;
    feedback_form?: any;
}

interface FeedbackState {
    loading: boolean;
    error: string | null;
    success: boolean;
}

const initialState: FeedbackState = {
    loading: false,
    error: null,
    success: false,
};

const feedbackSlice = createSlice({
    name: "feedback",
    initialState,
    reducers: {
        feedbackRequest: (state, _action: PayloadAction<FeedbackPayload>) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        },
        feedbackSuccess: (state) => {
            state.loading = false;
            state.success = true;
        },
        feedbackFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { feedbackRequest, feedbackSuccess, feedbackFailure } = feedbackSlice.actions;
export const feedbackReducer = feedbackSlice.reducer;
export const feedbackActionTypes = feedbackSlice.actions;
